<template>
  <v-container class="minHeight">
    <v-card class="pb-5">
      <v-toolbar class="secondary"
                 flat
                 :height="toolbarHeight"
                 :class="{'py-3': isSmallScreen}">

        <v-layout row
                  wrap>
          <v-flex xs12
                  class="align-self-center">
            <span class="white--text "
                  :class="{'right mb-3': isSmallScreen, 'headline': $vuetify.breakpoint.mdAndUp}"
                  v-html="$t('godfather.share.tip', { gift: this.giftGodfather, giftPark: this.giftGodfatherPark })">
            </span>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <h1 class="text-xs-center primary--text pt-4">
        {{$t('godfather.share.title')}}
      </h1>
      <v-layout row
                wrap
                justify-center
                class="pt-5">
        <v-flex xs6
                sm2>
          <v-card class="pointer pt-4 ma-2"
                  hover
                  @click="shareFacebook">
            <v-img :src="`/image/facebook.svg`"
                   contain
                   height="100"></v-img>
            <v-card-title class="justify-center">{{$t('godfather.share.option.facebook')}}
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs6
                sm2>
          <v-card class="pointer pt-4 ma-2"
                  hover
                  @click="shareTwitter">
            <v-img :src="`/image/twitter-x.svg`"
                   contain
                   height="100"></v-img>
            <v-card-title class="justify-center">{{$t('godfather.share.option.twitter')}}
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs6
                sm2>
          <v-card class="pointer pt-4 ma-2"
                  hover
                  @click="isShowingMailDialog = true">
            <v-img :src="`/image/mail.svg`"
                   contain
                   height="100"></v-img>
            <v-card-title class="justify-center">{{$t('godfather.share.option.mail')}}
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs6
                sm2>
          <v-card class="pointer pt-4 ma-2"
                  hover
                  v-clipboard:copy="message"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError">
            <v-img :src="`/image/link.svg`"
                   contain
                   height="100"></v-img>
            <v-card-title class="justify-center">{{$t('godfather.share.option.link')}}
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>

      <mail v-if="isShowingMailDialog"
            @on-close="closeMailDialog"></mail>

      <godsons></godsons>
    </v-card>
  </v-container>
</template>

<script>
import Advice from '@/components/commons/Advice';
import bitlyService from '@/services/bitlyService';
import utilService from '@/services/utilService';
import manageErrorService from '@/services/manageErrorService';
import Godsons from '@/components/private/balance/Godsons';
import Mail from '@/components/private/balance/Mail';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import store from '@/store';
import moment from 'moment';
import _ from 'lodash'

const configFile = require(process.env.VUE_APP_CONFIG);
const config = configFile.config;

export default {
  name: 'Godfather',
  components: {
    [Godsons.name]: Godsons,
    [Advice.name]: Advice,
    [Mail.name]: Mail
  },
  computed: {
    countParkings() {
      return config.SITE[store.state.countrySelected.code].MKT[store.state.citySelected.code].PARKINGS;
    },
    isSmallScreen() {
      return this.$vuetify.breakpoint.xs;
    },
    toolbarHeight() {
      return this.$vuetify.breakpoint.xs ? '100px' : '125px';
    },
    price() {
      let price = store.state.countrySelected.prices.hour;
      return this.$options.filters.addCurrencySymbol(price);
    },
    gift() {
      let price = store.state.countrySelected.prices.register;
      return this.$options.filters.addCurrencySymbol(price);
    },
    giftGodfather() {
      let gift = store.state.countrySelected.prices.godfather
      return this.$options.filters.addCurrencySymbol(gift);
    },
    giftGodfatherPark() {
      let gift = store.state.countrySelected.prices.godfatherRegister
      return this.$options.filters.addCurrencySymbol(gift);
    },
    user() {
      return store.state.user;
    },
    shareUrlHost() {
      if (utilService.isChile()) {
        return 'https://www.wesmartpark.com/chile'
      } else {
        return 'https://www.wesmartpark.com/spain'
      }
    },
    otherUrl() {
        return this.shareUrlHost + '/social/other/ayuda-a-tu-amigo/iniciar-registro?godfather=' + this.user.username
    },
    twitterUrl() {
        return this.shareUrlHost + '/social/twitter/ayuda-a-tu-amigo/iniciar-registro?godfather=' + this.user.username
    },
    facebookLink() {
      return `${this.shareUrlHost}/social/facebook/ayuda-a-tu-amigo/iniciar-registro?nocache=${moment().valueOf()}&godfather=${this.user.username}`
    }
  },
  data() {
    return {
      isShowingMailDialog: false,
      message: ''
    };
  },
  async mounted() {
    await this.setPasteLink(this.otherUrl)
  },
  methods: {
    async loadBitlyLink(url) {
      let params = {
        url: url
      }
      let results = await bitlyService.getCode(params)

      if (results.error) {
        manageErrorService.handle(results.data)
        return
      }

      return results.data ? results.data.link : url
    },
    async setPasteLink(url) {
      this.message = await this.loadBitlyLink(url)
    },

    onCopy: function(e) {
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('godfather.link.toast.success'),
        type: 'info',
        doNotTranslate: true
      });
    },
    onError: function(e) {},

    closeMailDialog() {
      this.isShowingMailDialog = false;
    },
    async shareFacebook() {
      return this.popup('https://www.facebook.com/dialog/share_open_graph', {
        app_id: '1541411459435997',
        action_type: 'og.likes',
        display: 'popup',
        redirect_uri: `${window.location}#close_window?token=${moment()}`,
        action_properties: JSON.stringify({
          object: await this.loadBitlyLink(this.facebookLink)
        })
      });
    },
    async shareTwitter() {
      return this.popup('https://twitter.com/intent/tweet', {
        text: this.$i18n.t('godfather.share.twitter', {parkings: this.countParkings, price: this.price, gift: this.gift}),
        url: await this.loadBitlyLink(this.twitterUrl)
      });
    },
    popup(url, params) {
      if (params == null) {
        params = {};
      }
      let popup = {
        width: 500,
        height: 350
      };
      popup.top = screen.height / 2 - popup.height / 2;
      popup.left = screen.width / 2 - popup.width / 2;

      let qs = _.chain(params)
        .map((value, key) => {
          return `${key}=${this.encode(value)}`;
        })
        .join('&')
        .value();

      if (qs) {
        qs = '?' + qs;
      }
      return window.open(url + qs, '_tab', 'scrollbars=yes,resizable=yes,left=' + popup.left + ',top=' + popup.top + ',width=' + popup.width + ',height=' + popup.height);
    },
    is_encoded(str) {
      return decodeURIComponent(str) !== str;
    },
    encode(str) {
      if (this.is_encoded(str)) {
        return str;
      } else {
        return encodeURIComponent(str);
      }
    }
  }
};
</script>
